import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { retry } from 'rxjs';

import { resolvePagePath } from '@core/routing/resolve-page-path';
import { LocalStorageService } from 'src/app/connectors/localstorage';
import { LogsService } from '../services/logs.service';
import { CreateLog } from '../models/request/create-log.model';
import { environment } from '@environments/environment';

export interface CreateLogResolverOptions {
  /** Also logs access in the QA environment. By default, only logs in production. */
  logInQa?: boolean;
}

export function createLogResolver(options: CreateLogResolverOptions = {}): ResolveFn<boolean> {
  return (route: ActivatedRouteSnapshot) => {
    const localStorageService = inject(LocalStorageService);
    const logsService = inject(LogsService);
    const document = inject(DOCUMENT);

    const isQa = document.location.hostname.startsWith('qa-');
    const shouldLog = environment.production || (!!options.logInQa && isQa);

    if (!shouldLog) {
      return true;
    }

    setTimeout(() => {
      try {
        const userId = Number(localStorageService.decryptAndGet('userId'));

        if (!userId || userId < 0) {
          return;
        }

        const pagePath = resolvePagePath(route);
        if (!pagePath) {
          return;
        }

        const params: CreateLog = { userId, pagePath };

        logsService
          .createLog(params)
          .pipe(retry(3))
          .subscribe({
            error: (err) => console.error('Background logging failed', err)
          });
      } catch (e) {
        console.warn('Erro ao tentar gerar log no resolver', e);
      }
    }, 0);

    return true;
  };
}
